import React from 'react';

import { ChakraProvider } from "@chakra-ui/react";
import { system } from "@/components/ui/theme";
import { Button, ButtonGroup } from "@chakra-ui/react"
import { Checkbox } from "@/components/ui/checkbox"
import { BrowserRouter, Routes, Route } from "react-router";
import Home from "@/pages/home"
import ShopLayout from "@/layouts/shop"
import ShopLayout2 from "@/layouts/theme_2"
import { StoreProvider } from "@/contexts/store"

const App = () => {

    return (
        <StoreProvider>
        
                <BrowserRouter>

                    <ShopLayout />

                    {/* <Routes>
                    <Route path="/" element={<ShopLayout />} />
                </Routes> */}
                </BrowserRouter>
          
        </StoreProvider>
    )
}

export default App;
